module.exports = __webpack_public_path__ + "img/search.5a724a2c.svg";